export default __webpack_public_path__ + "static/media/radiant-bright-blue-pink.823385e6.jpg";